"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n        display: auto;\n        top: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n        position: fixed;\n        padding: 0 ", "rem;\n        background: rgba(0, 0, 0, 0.6);\n        z-index: 999;\n    "], ["\n        display: auto;\n        top: 0;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n        position: fixed;\n        padding: 0 ", "rem;\n        background: rgba(0, 0, 0, 0.6);\n        z-index: 999;\n    "]),
    _templateObject2 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    margin: 6em auto;\n    position: relative;\n    border-radius: ", "em;\n    background: ", ";\n    padding: ", "em\n        0 0;\n    color: ", ";\n"], ["\n    max-width: ", ";\n    margin: 6em auto;\n    position: relative;\n    border-radius: ", "em;\n    background: ", ";\n    padding: ", "em\n        0 0;\n    color: ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n    top: 0;\n    right: 0;\n    padding: 0;\n    opacity: 0.5;\n    cursor: pointer;\n    position: absolute;\n    margin: ", "rem;\n    color: ", ";\n"], ["\n    top: 0;\n    right: 0;\n    padding: 0;\n    opacity: 0.5;\n    cursor: pointer;\n    position: absolute;\n    margin: ", "rem;\n    color: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require("./icon");

var _icon2 = _interopRequireDefault(_icon);

var _animateCssStyledComponents = require("animate-css-styled-components");

var _functions = require("../functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// Set to animate in / out based on visibility
var animation = {
    fade: _animateCssStyledComponents.FadeIn,
    zoom: _animateCssStyledComponents.ZoomIn
};

var ModalWrapper = animation.fade.extend(_templateObject, function (props) {
    return props.theme.modal.padding;
});
var ModalInner = animation.zoom.extend(_templateObject2, function (props) {
    return props.maxWidth;
}, function (props) {
    return props.theme.modal.radius;
}, function (props) {
    return props.theme.modal.background;
}, function (props) {
    return props.theme.modal.padding;
}, function (props) {
    return props.theme.modal.color;
});
var ModalCloseButton = _styledComponents2.default.div.attrs({
    role: "button"
})(_templateObject3, function (props) {
    return props.theme.modal.margin;
}, function (props) {
    return props.theme.modal.closeButtonColor;
});

/** Modal  */

var Modal = function (_React$Component) {
    _inherits(Modal, _React$Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        _this.onClose = function () {
            _this.setState({ visible: false });
            _this.props.onClose();
        };

        _this.renderModal = function () {
            var _this$props = _this.props,
                maxWidth = _this$props.maxWidth,
                children = _this$props.children;

            return _react2.default.createElement(
                ModalWrapper,
                { duration: "0.25s", onClick: _this.onClose },
                _react2.default.createElement(
                    ModalInner,
                    {
                        duration: "0.25s",
                        onClick: function onClick(e) {
                            return e.stopPropagation();
                        },
                        maxWidth: maxWidth
                    },
                    _react2.default.createElement(
                        ModalCloseButton,
                        { onClick: _this.onClose },
                        _react2.default.createElement(_icon2.default, { name: "close", size: "1.8" })
                    ),
                    _this.props.children
                )
            );
        };

        if ((0, _functions.isBrowser)()) {
            _this.el = document.createElement("div");
        }
        return _this;
    }

    _createClass(Modal, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            // init portal element
            if ((0, _functions.isBrowser)()) {
                try {
                    document.getElementsByTagName("BODY")[0].appendChild(this.el);
                } catch (err) {}
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            // destroy portal element
            if ((0, _functions.isBrowser)()) {
                try {
                    document.getElementsByTagName("BODY")[0].removeChild(this.el);
                } catch (err) {}
            }
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            //bodyElement.style.overflow = this.props.visible ? "hidden" : "visible";
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                theme = _props.theme,
                visible = _props.visible;


            if (visible && (0, _functions.isBrowser)()) {
                return _reactDom2.default.createPortal(this.renderModal(), this.el);
            } else {
                return null;
            }
        }
    }]);

    return Modal;
}(_react2.default.Component);

Modal = (0, _styledComponents.withTheme)(Modal);

Modal.displayName = "Modal";

Modal.propTypes = {
    /** Boolean indicating whether the modal should show */
    visible: _propTypes2.default.bool.isRequired,
    /** The function to call when the modal is closed */
    onClose: _propTypes2.default.func.isRequired,
    maxWidth: _propTypes2.default.string
};

Modal.defaultProps = {
    visible: false,
    maxWidth: "640px"
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/modal.js
// module id = 1014
// module chunks = 95715928098905 168707334958949